
import styled from 'styled-components'

const MyDiv = styled.div`

@import url("https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Manrope:wght@400;500;600;700;800&display=swap");



html,
body,
#root {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden !important;
}

.induction-experience {
  --ink: #0e1c2f;
  --ink-2: #3d4f68;
  --muted: #6a7b92;
  --hairline: rgba(14, 28, 47, 0.09);
  --hairline-strong: rgba(14, 28, 47, 0.16);
  --surface: rgba(255, 255, 255, 0.74);
  --surface-solid: #ffffff;
  --navy: #12243d;
  --navy-2: #1c3556;

  --shadow-xs: 0 1px 2px rgba(14, 28, 47, 0.06);
  --shadow-sm: 0 1px 2px rgba(14, 28, 47, 0.05), 0 6px 16px rgba(14, 28, 47, 0.06);
  --shadow-md: 0 2px 4px rgba(14, 28, 47, 0.04), 0 14px 34px rgba(14, 28, 47, 0.1);
  --shadow-lg: 0 4px 8px rgba(14, 28, 47, 0.04), 0 28px 60px rgba(14, 28, 47, 0.14);

  position: relative;
  display: block;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  min-height: 0;
  overflow: hidden !important;
  overflow: clip;
  color: var(--ink);
  background: #f3f7fa;
  font-family: "DM Sans", system-ui, sans-serif;
  scroll-behavior: smooth;
  overscroll-behavior: none;
  touch-action: pan-x;
  -webkit-font-smoothing: antialiased;
}

.induction-experience *,
.induction-experience *::before,
.induction-experience *::after {
  box-sizing: border-box;
}

.induction-experience button:focus-visible,
.induction-experience input:focus-visible,
.induction-experience textarea:focus-visible {
  outline: 2px solid var(--scene-accent, #0f8a73);
  outline-offset: 2px;
}

/* ---------- Progress rail ------------------------------------------------ */
.induction-progress-rail {
  position: fixed;
  z-index: 100;
  inset: 0 0 auto;
  height: 3px;
  background: rgba(14, 28, 47, 0.07);
  pointer-events: none;
}
.induction-progress-fill {
  height: 100%;
  border-radius: 0 3px 3px 0;
  background: linear-gradient(90deg, #0f8a73, #3f7be0 60%, #7b5cd6);
  box-shadow: 0 0 12px rgba(63, 123, 224, 0.35);
  transition: width 0.45s ease;
}

/* ---------- Scene shell -------------------------------------------------- */
.induction-scene {
  /* chapter tokens (overridden per chapter below) */
  --scene-ink: var(--ink);
  --scene-muted: var(--ink-2);
  --scene-accent: #0f8a73;
  --scene-accent-strong: #0a6554;
  --scene-accent-soft: #d8f1ea;
  --scene-tint-a: #f4f9fb;
  --scene-tint-b: #e2f1f1;
  --scene-blob-a: rgba(63, 183, 160, 0.22);
  --scene-blob-b: rgba(92, 150, 224, 0.16);
  --scene-line: var(--hairline);

  position: relative;
  isolation: isolate;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  min-height: 0 !important;
  max-height: 100dvh;
  padding: clamp(12px, 2.2vh, 24px) clamp(22px, 5.2vw, 88px) 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden !important;
  color: var(--scene-ink);
  scroll-margin-top: 0;
  background:
    radial-gradient(ellipse 46% 52% at 82% 40%, var(--scene-blob-a), transparent 70%),
    radial-gradient(ellipse 40% 46% at 8% 92%, var(--scene-blob-b), transparent 70%),
    linear-gradient(135deg, var(--scene-tint-a) 0%, var(--scene-tint-b) 100%);
}

/* soft ring + dot grid, kept very quiet */
.induction-scene::before,
.induction-scene::after {
  content: "";
  position: absolute;
  z-index: -1;
  pointer-events: none;
}
.induction-scene::before {
  width: 54vw;
  height: 54vw;
  min-width: 420px;
  min-height: 420px;
  right: -16vw;
  top: -26vw;
  border-radius: 50%;
  border: 1px solid var(--hairline);
  box-shadow: 0 0 0 48px rgba(255, 255, 255, 0.22), 0 0 0 49px var(--hairline),
    0 0 0 98px rgba(255, 255, 255, 0.14);
}
.induction-scene::after {
  inset: 0;
  opacity: 0.55;
  background-image: radial-gradient(rgba(14, 28, 47, 0.13) 1px, transparent 1.2px);
  background-size: 26px 26px;
  mask-image: radial-gradient(ellipse 60% 70% at 78% 45%, #000, transparent 75%);
  -webkit-mask-image: radial-gradient(ellipse 60% 70% at 78% 45%, #000, transparent 75%);
}
.scene-grain {
  position: absolute;
  z-index: -1;
  inset: 0;
  pointer-events: none;
  opacity: 0.05;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.5'/%3E%3C/svg%3E");
  mix-blend-mode: multiply;
}

/* ---------- Chapter colourways ------------------------------------------ */
.induction-scene-company {
  --scene-accent: #0f8a73;
  --scene-accent-strong: #0a6554;
  --scene-accent-soft: #d8f1ea;
  --scene-tint-a: #f5fafb;
  --scene-tint-b: #e1f1f0;
  --scene-blob-a: rgba(63, 183, 160, 0.24);
  --scene-blob-b: rgba(92, 150, 224, 0.15);
}
.induction-scene-branch {
  --scene-accent: #b0691a;
  --scene-accent-strong: #864c0c;
  --scene-accent-soft: #fbe9cc;
  --scene-tint-a: #fcf9f4;
  --scene-tint-b: #f6e9d6;
  --scene-blob-a: rgba(235, 170, 90, 0.26);
  --scene-blob-b: rgba(222, 130, 110, 0.14);
}
.induction-scene-business {
  --scene-accent: #3f5fd0;
  --scene-accent-strong: #2c45a6;
  --scene-accent-soft: #e0e7ff;
  --scene-tint-a: #f6f8fe;
  --scene-tint-b: #e3e9fb;
  --scene-blob-a: rgba(100, 130, 235, 0.25);
  --scene-blob-b: rgba(150, 110, 230, 0.14);
}
.induction-scene-department {
  --scene-accent: #2a8a4e;
  --scene-accent-strong: #1c6a3a;
  --scene-accent-soft: #daf2e0;
  --scene-tint-a: #f5faf6;
  --scene-tint-b: #e1f1e6;
  --scene-blob-a: rgba(90, 190, 130, 0.24);
  --scene-blob-b: rgba(80, 170, 190, 0.14);
}
.induction-scene-policies {
  --scene-accent: #7a48c2;
  --scene-accent-strong: #5b2f99;
  --scene-accent-soft: #eadffb;
  --scene-tint-a: #f9f6fd;
  --scene-tint-b: #ece3f8;
  --scene-blob-a: rgba(160, 110, 225, 0.24);
  --scene-blob-b: rgba(225, 120, 170, 0.12);
}
.induction-scene-feedback {
  --scene-accent: #0b8d86;
  --scene-accent-strong: #076761;
  --scene-accent-soft: #d6f2ef;
  --scene-tint-a: #f4fafa;
  --scene-tint-b: #dff1ee;
  --scene-blob-a: rgba(60, 185, 170, 0.24);
  --scene-blob-b: rgba(90, 140, 220, 0.14);
}

/* ---------- Top bar ------------------------------------------------------ */
.scene-topbar,
.scene-footer {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.scene-topbar {
  flex: 0 0 auto;
  min-height: 40px;
}
.scene-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.scene-brand-mark {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  color: #fff;
  font: 800 17px "Manrope", sans-serif;
  background: linear-gradient(145deg, var(--navy-2), var(--navy));
  box-shadow: 0 6px 14px rgba(18, 36, 61, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.18);
}
.scene-brand-name {
  color: var(--ink);
  font: 700 12.5px "Manrope", sans-serif;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
}
.scene-brand-divider {
  width: 1px;
  height: 18px;
  background: var(--hairline-strong);
}
.scene-brand-context {
  color: var(--muted);
  font: 600 9.5px "Manrope", sans-serif;
  letter-spacing: 0.14em;
  white-space: nowrap;
}
.scene-topbar-right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.scene-chapter-count {
  padding: 6px 11px;
  border-radius: 999px;
  border: 1px solid var(--hairline);
  background: var(--surface);
  color: var(--ink-2);
  font: 700 11.5px "Manrope", sans-serif;
  letter-spacing: 0.1em;
  box-shadow: var(--shadow-xs);
  backdrop-filter: blur(10px);
}
.scene-chapter-count i {
  padding: 0 5px;
  color: var(--hairline-strong);
  font-style: normal;
}
.scene-video-button.chakra-button {
  height: 34px;
  border: 1px solid var(--hairline-strong);
  border-radius: 999px;
  color: var(--ink);
  background: var(--surface-solid);
  font-size: 11px;
  font-weight: 600;
  box-shadow: var(--shadow-xs);
}
.scene-video-button.chakra-button:hover {
  background: #f1f5f9;
}

/* Sufi / Video segmented control */
.induction-view-toggle {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 4px;
  border: 1px solid var(--hairline);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: var(--shadow-sm);
  backdrop-filter: blur(14px);
}
.induction-view-toggle button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 8px 15px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--muted);
  font: 600 12px "Manrope", sans-serif;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}
.induction-view-toggle button:hover {
  color: var(--ink);
  background: rgba(14, 28, 47, 0.05);
}
.induction-view-toggle button.is-active {
  color: #fff;
  background: linear-gradient(145deg, var(--navy-2), var(--navy));
  box-shadow: 0 4px 12px rgba(18, 36, 61, 0.28);
}
.induction-view-toggle button span {
  font-size: 14px;
}

/* ---------- Main layout -------------------------------------------------- */
.scene-layout {
  position: relative;
  z-index: 2;
  flex: 1 1 auto;
  min-height: 0;
  max-height: 100%;
  width: min(100%, 1440px);
  margin: 0 auto;
  padding: clamp(8px, 1.8vh, 20px) 0;
  display: grid;
  grid-template-columns: minmax(0, 1.12fr) minmax(300px, 0.88fr);
  align-items: center;
  gap: clamp(20px, 3.4vw, 56px);
  overflow: hidden;
}
.scene-copy {
  min-width: 0;
  max-width: 760px;
  max-height: 100%;
  overflow: hidden;
  animation: scene-copy-in 0.7s cubic-bezier(0.2, 0.75, 0.2, 1) both;
}

.scene-eyebrow,
.scene-feedback-heading {
  display: flex;
  align-items: center;
  gap: 11px;
  color: var(--scene-accent-strong);
  font: 700 10.5px "Manrope", sans-serif;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
.scene-eyebrow-line {
  display: inline-block;
  width: 28px;
  height: 2px;
  border-radius: 2px;
  background: var(--scene-accent);
}

.scene-heading-wrap {
  position: relative;
  margin: clamp(10px, 1.8vh, 20px) 0 clamp(8px, 1.5vh, 16px);
}
.scene-oversized-number {
  position: absolute;
  z-index: -1;
  left: -8px;
  top: clamp(-58px, -7vh, -38px);
  font: 800 clamp(100px, 13vw, 190px) / 1 "Manrope", sans-serif;
  letter-spacing: -0.1em;
  color: var(--scene-accent);
  opacity: 0.09;
  user-select: none;
}
.scene-title {
  max-width: 780px;
  color: var(--ink) !important;
  font: 800 clamp(36px, 4.8vw, 68px) / 1.02 "Manrope", sans-serif !important;
  letter-spacing: -0.055em !important;
  text-wrap: balance;
}
.scene-intro {
  max-width: 640px;
  color: var(--scene-muted) !important;
  font: 400 clamp(13px, 1.15vw, 16px) / 1.6 "DM Sans", sans-serif !important;
}

/* Narration highlight */
.sufi-word-active {
  color: var(--scene-accent-strong) !important;
  background: var(--scene-accent-soft);
  border-radius: 5px;
  padding: 1px 4px;
  font-weight: 700;
  box-shadow: inset 0 -2px 0 var(--scene-accent);
}
.sufi-word-read {
  color: var(--scene-accent-strong);
  font-weight: 600;
}

/* ---------- Stats -------------------------------------------------------- */
.scene-stats {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 12px;
  margin-top: clamp(12px, 2vh, 22px);
  max-width: 920px;
}
.scene-stat {
  position: relative;
  min-width: 180px;
  min-height: 78px;
  padding: 14px 18px 14px 20px;
  border-radius: 16px;
  border: 1px solid var(--hairline);
  background: var(--surface);
  box-shadow: var(--shadow-sm);
  backdrop-filter: blur(14px);
  transition: border-color 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
}
.scene-stat::before {
  content: "";
  position: absolute;
  left: 0;
  top: 16px;
  bottom: 16px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: var(--scene-accent);
  opacity: 0.55;
}
.scene-stat.is-speaking {
  border-color: var(--scene-accent);
  background: #fff;
  box-shadow: 0 0 0 4px var(--scene-accent-soft), var(--shadow-md);
}
.scene-stat.is-speaking::before {
  opacity: 1;
}
.scene-stat-value {
  display: block;
  color: var(--ink);
  font: 800 clamp(20px, 2.1vw, 28px) / 1.1 "Manrope", sans-serif;
  letter-spacing: -0.035em;
}
.scene-stat-label {
  display: block;
  margin-top: 6px;
  color: var(--muted);
  font-size: 11.5px;
  line-height: 1.35;
}
.branch-head-image {
  width: 60px !important;
  height: 60px !important;
  min-width: 60px;
  object-fit: cover;
  border-radius: 14px !important;
  border: 2px solid #fff;
  box-shadow: var(--shadow-sm);
}
.branch-head-profile {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* ---------- Items / team cards ------------------------------------------ */
.scene-items {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  max-width: 780px;
  margin-top: clamp(10px, 1.7vh, 18px);
}
.scene-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  min-width: 0;
  min-height: 64px;
  padding: 12px 14px;
  text-align: left;
  color: var(--ink);
  border: 1px solid var(--hairline);
  border-radius: 14px;
  background: var(--surface);
  box-shadow: var(--shadow-xs);
  backdrop-filter: blur(12px);
  transition: transform 0.22s ease, background 0.22s ease, border-color 0.22s ease,
    box-shadow 0.22s ease;
}
.scene-item.is-speaking {
  border-color: var(--scene-accent);
  background: #fff;
  box-shadow: 0 0 0 4px var(--scene-accent-soft), var(--shadow-sm);
}
.scene-item.is-interactive {
  cursor: pointer;
}
.scene-item.is-interactive:hover {
  transform: translateY(-2px);
  border-color: var(--scene-accent);
  background: #fff;
  box-shadow: var(--shadow-md);
}
.scene-item-index {
  flex: 0 0 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: var(--scene-accent-strong);
  background: var(--scene-accent-soft);
  font: 800 10.5px "Manrope", sans-serif;
}
.scene-item-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.scene-item-copy strong {
  color: var(--ink);
  font: 700 12.5px "Manrope", sans-serif;
}
.scene-item-copy > span {
  color: var(--muted);
  font-size: 11px;
  line-height: 1.5;
}
.scene-item-action {
  align-self: center;
  flex: 0 0 auto;
  padding: 5px 10px;
  border-radius: 999px;
  color: var(--scene-accent-strong);
  background: var(--scene-accent-soft);
  font: 700 10px "Manrope", sans-serif;
  white-space: nowrap;
  transition: background 0.2s ease, color 0.2s ease;
}
.scene-item.is-interactive:hover .scene-item-action {
  color: #fff;
  background: var(--scene-accent);
}

.scene-item.scene-team-item {
  align-items: center;
  min-height: 70px;
  padding: 10px 12px;
}
.scene-team-item .scene-item-copy {
  flex: 1;
  justify-content: center;
  gap: 4px;
}
.scene-team-item .scene-item-copy strong {
  display: block;
  line-height: 1.35;
  overflow-wrap: anywhere;
}
.scene-team-item .scene-item-copy > span {
  display: block;
  line-height: 1.4;
  overflow-wrap: anywhere;
}
.scene-team-item .scene-item-action {
  margin-left: auto;
}

/* Business cards (if used) */
.scene-businesses {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 24px;
}
.scene-business-card {
  min-height: 120px;
  padding: 20px 22px;
  border-radius: 16px;
  border: 1px solid var(--hairline);
  background: var(--surface);
  box-shadow: var(--shadow-sm);
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}
.scene-business-card:hover {
  transform: translateY(-2px);
  border-color: var(--scene-accent);
  box-shadow: var(--shadow-md);
}

.scene-asset-wrap {
  max-width: 700px;
  margin-top: 10px;
}
.scene-asset-wrap > div {
  margin-bottom: 0 !important;
  background: rgba(255, 255, 255, 0.92) !important;
  border-radius: 16px !important;
  box-shadow: var(--shadow-sm);
}

.scene-feedback {
  max-width: 720px;
  margin-top: 12px;
  padding: 16px;
  border: 1px solid var(--hairline);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.95);
  color: #152235;
  box-shadow: var(--shadow-lg);
}
.scene-feedback-heading {
  margin-bottom: 14px;
}
.scene-feedback .chakra-form__label,
.scene-feedback [role="group"] > p {
  color: #243548;
}

.scene-bottomline {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  margin-top: clamp(10px, 1.7vh, 18px);
  padding-top: 10px;
  border-top: 1px dashed var(--hairline-strong);
  color: var(--muted);
  font: 600 8.5px "Manrope", sans-serif;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

/* ---------- Sufi guide --------------------------------------------------- */
.scene-guide {
  position: relative;
  width: min(100%, 520px);
  height: 100%;
  min-height: 0;
  max-height: 100%;
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  animation: guide-in 0.9s cubic-bezier(0.18, 0.75, 0.2, 1) 0.1s both;
}
.guide-glow {
  position: absolute;
  width: min(36vw, 430px);
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(circle, var(--scene-blob-a), transparent 68%);
  filter: blur(10px);
  animation: glow-breathe 5s ease-in-out infinite;
}
.guide-orbit {
  position: absolute;
  width: min(34vw, 390px);
  aspect-ratio: 1;
  border-radius: 50%;
  border: 1px solid var(--scene-accent);
  opacity: 0.22;
  transform: rotate(-24deg) scaleY(0.38);
}
.guide-orbit-one {
  animation: orbit-spin 22s linear infinite;
}
.guide-orbit-two {
  width: min(40vw, 460px);
  border-style: dashed;
  opacity: 0.16;
  transform: rotate(54deg) scaleY(0.34);
  animation: orbit-spin-reverse 30s linear infinite;
}
.guide-image-wrap {
  position: relative;
  z-index: 1;
  width: min(27vw, 330px);
  height: min(58vh, 430px);
  min-width: 190px;
  min-height: 0;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  filter: drop-shadow(0 26px 30px rgba(14, 28, 47, 0.2));
}
.guide-avatar {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: bottom center;
  transform-origin: 50% 85%;
  animation: avatar-float 5s ease-in-out infinite;
}
.scene-guide.is-speaking .guide-avatar {
  animation: avatar-float 3s ease-in-out infinite, avatar-speak 0.34s ease-in-out infinite alternate;
}

.guide-caption {
  position: absolute;
  z-index: 2;
  width: min(100%, 390px);
  right: 0;
  bottom: 0;
  padding: 16px 18px 14px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.82);
  color: var(--ink);
  backdrop-filter: blur(22px) saturate(1.3);
  box-shadow: var(--shadow-lg);
}
.guide-caption-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.guide-caption-top > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.guide-caption-top strong {
  color: var(--ink);
  font: 800 17px "Manrope", sans-serif;
}
.guide-caption-top > div span {
  color: var(--scene-accent-strong);
  font: 700 8.5px "Manrope", sans-serif;
  letter-spacing: 0.16em;
}
.guide-live-status {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 9px;
  border-radius: 999px;
  background: rgba(14, 28, 47, 0.05);
  color: var(--ink-2);
  font: 600 9.5px "Manrope", sans-serif;
  white-space: nowrap;
}
.guide-live-status i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #a3afbf;
}
.guide-live-status.is-live {
  color: var(--scene-accent-strong);
  background: var(--scene-accent-soft);
}
.guide-live-status.is-live i {
  background: var(--scene-accent);
  box-shadow: 0 0 0 4px var(--scene-accent-soft);
  animation: live-pulse 1.4s infinite;
}
.guide-caption p {
  max-height: 72px;
  overflow: auto;
  margin: 11px 0 12px;
  color: var(--ink-2);
  font-size: 11.5px;
  line-height: 1.6;
  scrollbar-width: thin;
}
.guide-waveform {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  height: 19px;
  overflow: hidden;
}
.guide-waveform i {
  width: 2px;
  height: 5px;
  border-radius: 4px;
  background: var(--scene-accent);
  opacity: 0.4;
  transform: scaleY(0.55);
}
.scene-guide.is-speaking .guide-waveform i {
  animation: wave 650ms ease-in-out infinite alternate;
  animation-delay: var(--wave-delay);
  opacity: 0.95;
}
.guide-controls {
  display: flex;
  gap: 8px;
  margin-top: 13px;
}
.guide-controls button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  font: 700 10.5px "Manrope", sans-serif;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}
.guide-control-primary {
  color: #fff;
  background: linear-gradient(145deg, var(--navy-2), var(--navy));
  border: 1px solid var(--navy);
  box-shadow: 0 4px 12px rgba(18, 36, 61, 0.25);
}
.guide-control-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(18, 36, 61, 0.3);
}
.guide-control-secondary {
  color: var(--ink);
  border: 1px solid var(--hairline-strong);
  background: #fff;
}
.guide-control-secondary:hover {
  background: #f1f5f9;
}
.guide-control-secondary.is-muted {
  opacity: 0.6;
}
.guide-nameplate {
  position: absolute;
  top: 18px;
  right: 3%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 11px;
  border-radius: 999px;
  border: 1px solid var(--hairline);
  background: var(--surface);
  color: var(--muted);
  font: 700 8px "Manrope", sans-serif;
  letter-spacing: 0.14em;
  backdrop-filter: blur(10px);
}
.guide-nameplate-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--scene-accent);
}

/* ---------- Footer ------------------------------------------------------- */
.scene-footer {
  flex: 0 0 auto;
  min-height: 48px;
  padding-top: 9px;
  padding-bottom: 2px;
  border-top: 1px solid var(--hairline);
}
.scene-footer-left {
  display: flex;
  align-items: baseline;
  gap: 9px;
  color: var(--muted);
  font: 600 8.5px "Manrope", sans-serif;
  letter-spacing: 0.13em;
}
.scene-footer-progress {
  color: var(--scene-accent-strong);
  font: 800 16px "Manrope", sans-serif;
  letter-spacing: -0.03em;
}
.scene-pagination {
  display: flex;
  align-items: center;
  gap: 7px;
}
.scene-pagination button {
  width: 7px;
  height: 7px;
  padding: 0;
  border: 0;
  border-radius: 20px;
  background: rgba(14, 28, 47, 0.18);
  cursor: pointer;
  transition: width 0.3s ease, background 0.3s ease;
}
.scene-pagination button:hover {
  background: rgba(14, 28, 47, 0.34);
}
.scene-pagination button.is-current {
  width: 30px;
  background: var(--scene-accent);
}
.scene-pagination button.is-done {
  background: var(--scene-accent);
  opacity: 0.45;
}
.scene-footer-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.scene-skip-button,
.scene-next-button {
  border: 0;
  cursor: pointer;
  font: 700 11px "Manrope", sans-serif;
}
.scene-skip-button {
  padding: 8px 10px;
  border-radius: 999px;
  color: var(--ink-2);
  background: transparent;
  transition: background 0.2s ease;
}
.scene-skip-button:hover:not(:disabled) {
  background: rgba(14, 28, 47, 0.06);
}
.scene-skip-button:disabled {
  opacity: 0.3;
  cursor: default;
}
.scene-next-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 17px;
  border-radius: 999px;
  color: #fff;
  background: linear-gradient(145deg, var(--navy-2), var(--navy));
  box-shadow: 0 6px 16px rgba(18, 36, 61, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.scene-next-button span {
  font-size: 14px;
}
.scene-next-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(18, 36, 61, 0.34);
}

/* ---------- Video view --------------------------------------------------- */
.scene-video-view {
  width: 100%;
 
  min-height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 5%;
  animation: induction-video-enter 0.25s ease;
}
.scene-video-view > * {
  width: 100%;
  max-width: 1100px;
  max-height: 100%;
  border-radius: 22px;
  overflow: hidden;

}
.scene-item-image {
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 50%;
  object-fit: cover;
}
/* Branch head image fits flush inside the card */
.scene-stat:has(.branch-head-image) {
  padding: 0 !important;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  min-height: 78px;
}
.scene-stat::before {
  display: none !important;
}

.branch-head-card-content {
  display: flex;
  align-items: stretch;
  gap: 0 !important;
  width: 100%;
  height: 100%;
}

.branch-head-image {
  width: 88px !important;
  height: auto !important;
  min-width: 88px;
  align-self: stretch;
  object-fit: cover;
  object-position: center top;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.branch-head-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 16px;
  min-width: 0;
}
/* ---------- Keyframes ---------------------------------------------------- */
@keyframes scene-copy-in {
  from { opacity: 0; transform: translate3d(0, 22px, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); }
}
@keyframes guide-in {
  from { opacity: 0; transform: translate3d(24px, 12px, 0) scale(0.97); }
  to { opacity: 1; transform: translate3d(0, 0, 0) scale(1); }
}
@keyframes avatar-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}
@keyframes avatar-speak {
  from { filter: brightness(1); }
  to { filter: brightness(1.04); }
}
@keyframes glow-breathe {
  0%, 100% { opacity: 0.7; transform: scale(0.94); }
  50% { opacity: 1; transform: scale(1.05); }
}
@keyframes orbit-spin {
  from { transform: rotate(-24deg) scaleY(0.38); }
  to { transform: rotate(336deg) scaleY(0.38); }
}
@keyframes orbit-spin-reverse {
  from { transform: rotate(54deg) scaleY(0.34); }
  to { transform: rotate(-306deg) scaleY(0.34); }
}
@keyframes wave {
  from { transform: scaleY(0.35); }
  to { transform: scaleY(2.3); }
}
@keyframes live-pulse {
  0%, 100% { box-shadow: 0 0 0 3px var(--scene-accent-soft); }
  50% { box-shadow: 0 0 0 6px transparent; }
}
@keyframes induction-video-enter {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes induction-tool-pop {
  from { opacity: 0; transform: translateY(10px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

/* =========================================================================
   WELCOME SCREEN
   ========================================================================= */
.induction-welcome {
  --welcome-accent: #0f8a73;
  --welcome-accent-strong: #0a6554;
  --welcome-accent-soft: #d8f1ea;
  --ink: #0e1c2f;
  --ink-2: #3d4f68;
  --muted: #6a7b92;
  --hairline: rgba(14, 28, 47, 0.09);
  --hairline-strong: rgba(14, 28, 47, 0.16);
  --navy: #12243d;
  --navy-2: #1c3556;
  --shadow-sm: 0 1px 2px rgba(14, 28, 47, 0.05), 0 6px 16px rgba(14, 28, 47, 0.06);
  --shadow-lg: 0 4px 8px rgba(14, 28, 47, 0.04), 0 28px 60px rgba(14, 28, 47, 0.14);

  position: relative;
  isolation: isolate;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  min-height: 0;
  max-height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: clamp(12px, 2.2vh, 22px) clamp(22px, 5.2vw, 88px) 12px;
  color: var(--ink);
  font-family: "DM Sans", system-ui, sans-serif;
  background:
    radial-gradient(ellipse 44% 50% at 80% 42%, rgba(63, 183, 160, 0.24), transparent 70%),
    radial-gradient(ellipse 38% 44% at 8% 92%, rgba(92, 150, 224, 0.16), transparent 70%),
    linear-gradient(135deg, #f6fafb 0%, #e3f1f1 100%);
}
.induction-welcome::before {
  content: "";
  position: absolute;
  z-index: -1;
  width: 68vw;
  aspect-ratio: 1;
  right: -24vw;
  top: -35vw;
  border-radius: 50%;
  border: 1px solid var(--hairline);
  box-shadow: 0 0 0 60px rgba(255, 255, 255, 0.22), 0 0 0 61px var(--hairline),
    0 0 0 120px rgba(255, 255, 255, 0.14);
}
.induction-welcome::after {
  content: "";
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: 0.55;
  pointer-events: none;
  background-image: radial-gradient(rgba(14, 28, 47, 0.13) 1px, transparent 1.2px);
  background-size: 26px 26px;
  mask-image: radial-gradient(ellipse 60% 70% at 78% 45%, #000, transparent 75%);
  -webkit-mask-image: radial-gradient(ellipse 60% 70% at 78% 45%, #000, transparent 75%);
}
.welcome-ambient {
  position: absolute;
  z-index: -1;
  border-radius: 50%;
  filter: blur(40px);
  pointer-events: none;
}
.welcome-ambient-one { width: 320px; height: 320px; right: 18%; top: 25%; background: rgba(63, 183, 160, 0.16); }
.welcome-ambient-two { width: 220px; height: 220px; left: 3%; bottom: 4%; background: rgba(92, 150, 224, 0.16); }

.welcome-header,
.welcome-footer {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}
.welcome-header { flex: 0 0 auto; min-height: 38px; }
.welcome-header .scene-brand-mark {
  width: 36px; height: 36px; display: grid; place-items: center; border-radius: 11px;
  color: #fff; font: 800 17px "Manrope", sans-serif;
  background: linear-gradient(145deg, var(--navy-2), var(--navy));
  box-shadow: 0 6px 14px rgba(18, 36, 61, 0.25);
}
.welcome-header .scene-brand { display: flex; align-items: center; gap: 12px; }
.welcome-header .scene-brand-name { color: var(--ink); font: 700 12.5px "Manrope", sans-serif; letter-spacing: 0.06em; text-transform: uppercase; }
.welcome-header .scene-brand-divider { width: 1px; height: 18px; background: var(--hairline-strong); }
.welcome-header .scene-brand-context { color: var(--muted); font: 600 9.5px "Manrope", sans-serif; letter-spacing: 0.14em; }
.welcome-header-note,
.welcome-footer {
  color: var(--muted);
  font: 600 8px "Manrope", sans-serif;
  letter-spacing: 0.16em;
}

.welcome-main {
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  min-height: 0;
  width: min(100%, 1440px);
  margin: 0 auto;
  padding: clamp(8px, 1.5vh, 16px) 0;
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(320px, 0.92fr);
  align-items: center;
  gap: clamp(22px, 4vw, 64px);
}
.welcome-copy {
  min-width: 0;
  max-width: 760px;
  max-height: 100%;
  overflow: hidden;
  animation: scene-copy-in 0.8s cubic-bezier(0.2, 0.75, 0.2, 1) both;
}
.welcome-kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--hairline);
  background: rgba(255, 255, 255, 0.8);
  color: var(--welcome-accent-strong);
  font: 700 9.5px "Manrope", sans-serif;
  letter-spacing: 0.14em;
  box-shadow: var(--shadow-sm);
}
.welcome-kicker-dot {
  width: 7px; height: 7px; border-radius: 50%;
  background: var(--welcome-accent);
  box-shadow: 0 0 0 4px var(--welcome-accent-soft);
}
.welcome-greeting {
  margin: clamp(12px, 2vh, 20px) 0 8px;
  color: var(--ink-2);
  font: 500 14px "DM Sans", sans-serif;
}
.welcome-copy h1 {
  max-width: 720px;
  margin: 0;
  color: var(--ink);
  font: 800 clamp(42px, 5.1vw, 68px) / 0.98 "Manrope", sans-serif;
  letter-spacing: -0.06em;
  text-wrap: balance;
}
.welcome-copy h1 span {
  display: block;
  color: var(--welcome-accent);
}
.welcome-description {
  max-width: 590px;
  margin: clamp(12px, 1.8vh, 18px) 0 0;
  color: var(--ink-2);
  font-size: clamp(12px, 1vw, 14.5px);
  line-height: 1.65;
}
.welcome-meta {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: clamp(14px, 2vh, 22px);
}
.welcome-meta div { display: flex; flex-direction: column; gap: 3px; }
.welcome-meta strong { color: var(--ink); font: 800 19px "Manrope", sans-serif; }
.welcome-meta span { color: var(--muted); font: 700 8.5px "Manrope", sans-serif; letter-spacing: 0.14em; }
.welcome-meta > i { width: 1px; height: 26px; background: var(--hairline-strong); }

.welcome-start-button {
  display: inline-flex;
  align-items: center;
  gap: 18px;
  min-height: 48px;
  margin-top: clamp(14px, 2vh, 22px);
  padding: 5px 6px 5px 20px;
  border: 0;
  border-radius: 999px;
  color: #fff;
  background: linear-gradient(145deg, var(--navy-2), var(--navy));
  font: 700 12.5px "Manrope", sans-serif;
  box-shadow: 0 10px 24px rgba(18, 36, 61, 0.3);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.welcome-start-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 34px rgba(18, 36, 61, 0.36);
}
.welcome-start-button > span {
  width: 36px; height: 36px; display: grid; place-items: center; border-radius: 50%;
  color: var(--navy); background: #fff;
}

.welcome-chapters { max-width: 720px; margin-top: clamp(16px, 2.2vh, 24px); }
.welcome-chapters-heading {
  display: flex; justify-content: space-between; gap: 12px; margin-bottom: 8px;
  color: var(--muted); font: 700 8.5px "Manrope", sans-serif; letter-spacing: 0.15em;
}
.welcome-chapter-list { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 7px; }
.welcome-chapter {
  display: flex; align-items: center; gap: 8px; min-width: 0; min-height: 36px;
  padding: 8px 10px;
  border: 1px solid var(--hairline); border-radius: 11px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 1px 2px rgba(14, 28, 47, 0.04);
  backdrop-filter: blur(10px);
}
.welcome-chapter-number {
  flex: 0 0 auto; padding: 2px 6px; border-radius: 6px;
  color: var(--welcome-accent-strong); background: var(--welcome-accent-soft);
  font: 800 9px "Manrope", sans-serif;
}
.welcome-chapter-name {
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  color: var(--ink); font: 600 10px "Manrope", sans-serif;
}
.welcome-chapter-duration { display: none; }

.welcome-guide-stage {
  position: relative;
  min-width: 0;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  animation: guide-in 1s cubic-bezier(0.18, 0.75, 0.2, 1) 0.12s both;
}
.welcome-guide-glow {
  position: absolute; width: min(38vw, 460px); aspect-ratio: 1; border-radius: 50%;
  background: radial-gradient(circle, rgba(63, 183, 160, 0.3), transparent 68%);
  filter: blur(10px); animation: glow-breathe 5s ease-in-out infinite;
}
.welcome-guide-orbit {
  position: absolute; width: min(37vw, 430px); aspect-ratio: 1; border-radius: 50%;
  border: 1px solid var(--welcome-accent); opacity: 0.22;
  transform: rotate(-24deg) scaleY(0.38);
}
.welcome-guide-orbit-a { animation: orbit-spin 22s linear infinite; }
.welcome-guide-orbit-b {
  width: min(43vw, 500px); border-style: dashed; opacity: 0.16;
  transform: rotate(54deg) scaleY(0.34); animation: orbit-spin-reverse 30s linear infinite;
}
.welcome-guide-image {
  position: relative; z-index: 1;
  width: min(28vw, 350px); height: min(51vh, 410px);
  min-width: 220px; min-height: 0; max-height: 100%;
  display: flex; align-items: flex-end; justify-content: center;
  filter: drop-shadow(0 26px 30px rgba(14, 28, 47, 0.2));
}
.welcome-guide-image img {
  width: 100%; height: 100%; object-fit: contain; object-position: bottom center;
  animation: avatar-float 5s ease-in-out infinite;
}
.welcome-guide-message {
  position: absolute; z-index: 2; right: 0; bottom: clamp(4px, 1.5vh, 14px);
  width: min(100%, 370px); padding: 14px 16px 11px;
  border: 1px solid rgba(255, 255, 255, 0.9); border-radius: 20px;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(22px) saturate(1.3);
  box-shadow: var(--shadow-lg);
}
.welcome-guide-message-top { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.welcome-guide-message-top > div { display: flex; flex-direction: column; gap: 3px; }
.welcome-guide-message-top strong { color: var(--ink); font: 800 17px "Manrope", sans-serif; }
.welcome-guide-message-top > div span { color: var(--welcome-accent-strong); font: 700 8.5px "Manrope", sans-serif; letter-spacing: 0.15em; }
.welcome-ready {
  display: flex; align-items: center; gap: 6px; padding: 4px 9px; border-radius: 999px;
  color: var(--welcome-accent-strong); background: var(--welcome-accent-soft);
  font: 700 8.5px "Manrope", sans-serif; letter-spacing: 0.06em;
}
.welcome-ready i { width: 6px; height: 6px; border-radius: 50%; background: var(--welcome-accent); }
.welcome-guide-message p { margin: 8px 0 9px; color: var(--ink-2); font-size: 11px; line-height: 1.55; }
.welcome-employee-note {
  position: absolute; top: clamp(4px, 1.5vh, 14px); right: 0;
  display: flex; flex-direction: column; align-items: flex-end; gap: 4px; text-align: right;
}
.welcome-employee-note > span { color: var(--muted); font: 700 8.5px "Manrope", sans-serif; letter-spacing: 0.15em; }
.welcome-employee-note > strong { color: var(--ink); font: 800 16px "Manrope", sans-serif; }
.welcome-employee-note > small { color: var(--ink-2); font-size: 10.5px; }
.welcome-employee-details { display: grid; grid-template-columns: repeat(2, minmax(100px, 1fr)); gap: 6px 12px; margin-top: 7px; }
.welcome-employee-details div { display: flex; flex-direction: column; gap: 3px; }
.welcome-employee-details div span { color: var(--muted); font: 600 7.5px "Manrope", sans-serif; letter-spacing: 0.1em; text-transform: uppercase; }
.welcome-employee-details div strong { color: var(--ink); font: 600 9.5px "DM Sans", sans-serif; }
.welcome-footer { flex: 0 0 auto; min-height: 30px; padding-top: 8px; border-top: 1px solid var(--hairline); font-size: 7.5px; }

/* =========================================================================
   COMPLETION SCENE
   ========================================================================= */
.induction-completion-scene {
  min-height: 100svh !important;
  color: #0e1c2f !important;
  background:
    radial-gradient(ellipse 50% 45% at 50% 12%, rgba(63, 183, 160, 0.26), transparent 70%),
    radial-gradient(ellipse 40% 40% at 90% 90%, rgba(92, 150, 224, 0.16), transparent 70%),
    linear-gradient(135deg, #f6fafb 0%, #e3f1f1 100%) !important;
}
.induction-completion-scene::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.5;
  background-image: radial-gradient(rgba(14, 28, 47, 0.12) 1px, transparent 1.2px);
  background-size: 26px 26px;
}
.induction-completion-scene .completion-main-content { max-width: 900px !important; }
.induction-completion-scene h1 {
  color: #0e1c2f !important;
  font-family: "Manrope", sans-serif !important;
  font-weight: 800 !important;
  letter-spacing: -0.05em !important;
}
.induction-completion-scene .completion-main-content > div:nth-child(2) p {
  color: #3d4f68 !important;
}
.induction-completion-scene .completion-main-content > div:nth-child(3),
.induction-completion-scene .completion-main-content > div:nth-child(4) {
  box-shadow: 0 4px 8px rgba(14, 28, 47, 0.04), 0 28px 60px rgba(14, 28, 47, 0.12) !important;
}

/* =========================================================================
   FLOATING TOOLS — CHAT + NOTEPAD
   Round launchers on the right; label appears as a tooltip on hover.
   Panels open to the left of the launchers.
   ========================================================================= */
.induction-tools {
  position: fixed;
  z-index: 1000;
  right: 24px;
  bottom: 28px;
  font-family: "DM Sans", system-ui, sans-serif;
}

.induction-floating-actions {
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.induction-tool-panels {
  position: absolute;
  right: 68px;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 12px;
  margin: 0;
}

.induction-floating-actions .induction-tools-launcher,
.induction-tools-launcher {
  position: relative;
  width: 54px;
  height: 54px;
  min-height: 54px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  border-radius: 50%;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  box-shadow: 0 10px 26px rgba(14, 28, 47, 0.24);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.induction-floating-actions .induction-tools-launcher:hover,
.induction-tools-launcher:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 16px 34px rgba(14, 28, 47, 0.3);
}
.induction-chat-launcher { background: linear-gradient(145deg, #12a085, #0a6554); }
.induction-notes-launcher { background: linear-gradient(145deg, #4a73d9, #2b469c); }
.induction-floating-actions .induction-tools-launcher.is-active {
  outline: 2px solid var(--navy, #12243d);
  outline-offset: 3px;
}
.induction-floating-icon { font-size: 21px; line-height: 1; }
.induction-floating-label {
  position: absolute;
  right: calc(100% + 12px);
  top: 50%;
  padding: 6px 11px;
  border-radius: 9px;
  background: #12243d;
  color: #fff;
  font: 600 11px "Manrope", sans-serif;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transform: translate(6px, -50%);
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.induction-tools-launcher:hover .induction-floating-label,
.induction-tools-launcher:focus-visible .induction-floating-label {
  opacity: 1;
  transform: translate(0, -50%);
}

/* Legacy menu (kept for compatibility) */
.induction-tools-menu {
  display: flex; flex-direction: column; gap: 9px; width: 245px; padding: 10px;
  border: 1px solid var(--hairline-strong, rgba(14, 28, 47, 0.16)); border-radius: 17px;
  background: rgba(255, 255, 255, 0.95); box-shadow: 0 18px 55px rgba(14, 28, 47, 0.18);
  backdrop-filter: blur(20px); animation: induction-tool-pop 0.2s ease both;
}
.induction-tools-menu button {
  display: flex; align-items: center; gap: 11px; width: 100%; padding: 11px;
  border: 1px solid transparent; border-radius: 12px; text-align: left;
  color: #0e1c2f; background: rgba(14, 28, 47, 0.04); cursor: pointer;
}
.induction-tools-menu button:hover { border-color: rgba(15, 138, 115, 0.4); background: #d8f1ea; }
.induction-tool-menu-icon {
  width: 36px; height: 36px; flex: 0 0 36px; display: grid; place-items: center;
  border-radius: 11px; color: #fff; background: #0f8a73; font-size: 19px;
}
.induction-tools-menu button > span:last-child { display: flex; flex-direction: column; gap: 3px; }
.induction-tools-menu strong { font: 700 12px "Manrope", sans-serif; }
.induction-tools-menu small { color: #6a7b92; font-size: 10px; }

/* Panel card */
.induction-tool-panel {
  width: 370px;
  height: min(490px, calc(100dvh - 100px));
  flex: 0 0 370px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(14, 28, 47, 0.1);
  border-radius: 22px;
  color: #0e1c2f;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 4px 8px rgba(14, 28, 47, 0.05), 0 30px 70px rgba(14, 28, 47, 0.22);
  backdrop-filter: blur(22px);
  animation: induction-tool-pop 0.22s ease both;
}
.induction-tool-header {
  min-height: 64px;
  padding: 13px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid rgba(14, 28, 47, 0.08);
  background: linear-gradient(180deg, #f6f9fc, #fff);
}
.induction-tool-header > div { display: flex; flex-direction: column; gap: 4px; }
.induction-tool-header strong { color: #0e1c2f; font: 800 15px "Manrope", sans-serif; }
.induction-tool-header span { color: #0a6554; font: 700 8.5px "Manrope", sans-serif; letter-spacing: 0.15em; }
.induction-tool-header > button {
  width: 30px; height: 30px; border: 1px solid rgba(14, 28, 47, 0.12); border-radius: 50%;
  color: #3d4f68; background: #fff; font-size: 20px; line-height: 1; cursor: pointer;
  transition: background 0.2s ease;
}
.induction-tool-header > button:hover { background: #eef2f7; }

/* Chat */
.induction-chat-messages {
  flex: 1;
  min-height: 0;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  background: #f8fafc;
  scrollbar-width: thin;
  scrollbar-color: rgba(14, 28, 47, 0.22) transparent;
}
.induction-chat-messages::-webkit-scrollbar { width: 4px; }
.induction-chat-messages::-webkit-scrollbar-track { background: transparent; }
.induction-chat-messages::-webkit-scrollbar-thumb { background: rgba(14, 28, 47, 0.2); border-radius: 10px; }
.induction-chat-messages::-webkit-scrollbar-thumb:hover { background: rgba(14, 28, 47, 0.38); }
.induction-chat-message {
  max-width: 88%;
  padding: 10px 13px;
  border-radius: 15px;
  white-space: pre-wrap;
  font-size: 11.5px;
  line-height: 1.6;
}
.induction-chat-message.is-assistant {
  align-self: flex-start;
  color: #1d2f47;
  border: 1px solid rgba(14, 28, 47, 0.08);
  border-bottom-left-radius: 5px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(14, 28, 47, 0.05);
}
.induction-chat-message.is-user {
  align-self: flex-end;
  color: #fff;
  border-bottom-right-radius: 5px;
  background: linear-gradient(145deg, #1c3556, #12243d);
}
.induction-chat-message.is-typing { opacity: 0.7; font-style: italic; }
.induction-chat-form {
  display: flex;
  gap: 8px;
  padding: 11px;
  border-top: 1px solid rgba(14, 28, 47, 0.08);
  background: #fff;
}
.induction-chat-form input {
  flex: 1;
  min-width: 0;
  height: 40px;
  padding: 0 13px;
  border: 1px solid rgba(14, 28, 47, 0.14);
  border-radius: 12px;
  outline: none;
  color: #0e1c2f;
  background: #f6f9fc;
  font: 12px "DM Sans", sans-serif;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.induction-chat-form input:focus {
  border-color: #0f8a73;
  background: #fff;
  box-shadow: 0 0 0 3px #d8f1ea;
}
.induction-chat-form input::placeholder { color: #8d9bb0; }
.induction-chat-form button {
  width: 42px; height: 40px; border: 0; border-radius: 12px; color: #fff;
  background: linear-gradient(145deg, #12a085, #0a6554); font-size: 18px; cursor: pointer;
}
.induction-chat-form button:disabled { opacity: 0.4; cursor: not-allowed; }
.induction-chat-disclaimer { margin: 0; padding: 0 13px 10px; background: #fff; color: #8d9bb0; font-size: 9px; }

/* Notepad */
.induction-notes-panel textarea {
  flex: 1;
  min-height: 0;
  width: 100%;
  padding: 16px;
  resize: none;
  border: 0;
  outline: 0;
  color: #0e1c2f;
  background: repeating-linear-gradient(
    to bottom,
    #fffdf6 0,
    #fffdf6 30px,
    rgba(14, 28, 47, 0.08) 31px
  );
  font: 12.5px / 31px "DM Sans", sans-serif;
}
.induction-notes-panel textarea::placeholder { color: #a3afbf; }
.induction-notes-footer {
  min-height: 44px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-top: 1px solid rgba(14, 28, 47, 0.08);
  background: #fff;
}
.induction-notes-footer span { color: #8d9bb0; font-size: 9.5px; }
.induction-notes-footer button { border: 0; color: #0a6554; background: transparent; font: 700 10.5px "Manrope", sans-serif; cursor: pointer; }

/* =========================================================================
   RESPONSIVE
   ========================================================================= */
@media (max-width: 1000px) {
  .scene-layout { grid-template-columns: minmax(0, 1fr) minmax(260px, 0.72fr); gap: 22px; }
  .guide-image-wrap { width: 270px; }
  .guide-caption { width: min(100%, 350px); }
  .scene-title { font-size: clamp(34px, 5vw, 56px) !important; }

  .welcome-main { grid-template-columns: minmax(0, 1fr) minmax(280px, 0.7fr); gap: 24px; }
  .welcome-guide-image { width: 270px; }
  .welcome-copy h1 { font-size: clamp(40px, 6vw, 62px); }
  .welcome-chapter-list { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

/* Short laptop viewports */
@media (min-width: 721px) and (max-height: 850px) {
  .induction-scene { padding-top: 10px; padding-bottom: 8px; }
  .scene-layout { padding-top: 5px; padding-bottom: 5px; gap: 22px; }
  .scene-heading-wrap { margin-top: 8px; margin-bottom: 8px; }
  .scene-oversized-number { top: -48px; }
  .scene-stats { margin-top: 12px; }
  .scene-stat { min-height: 62px; padding: 10px 14px; }
  .scene-items { margin-top: 10px; gap: 7px; }
  .scene-item { min-height: 58px; padding: 9px 11px; }
  .scene-bottomline { margin-top: 10px; padding-top: 8px; }
  .guide-image-wrap { height: min(54vh, 390px); }
  .guide-caption { padding: 13px 15px 11px; }
  .scene-footer { min-height: 42px; padding-top: 7px; }
}
@media (min-width: 721px) and (max-height: 820px) {
  .induction-welcome { padding-top: 8px; padding-bottom: 7px; }
  .welcome-header { min-height: 34px; }
  .welcome-main { padding-top: 4px; padding-bottom: 4px; gap: 22px; }
  .welcome-greeting { margin: 10px 0 6px; font-size: 12px; }
  .welcome-copy h1 { font-size: clamp(38px, 4.5vw, 58px); line-height: 0.94; }
  .welcome-description { margin-top: 10px; font-size: 12px; line-height: 1.5; }
  .welcome-meta { margin-top: 12px; gap: 16px; }
  .welcome-start-button { margin-top: 12px; min-height: 42px; }
  .welcome-start-button > span { width: 32px; height: 32px; }
  .welcome-chapters { margin-top: 13px; }
  .welcome-chapter { min-height: 30px; padding: 6px 8px; }
  .welcome-guide-image { height: min(47vh, 350px); }
  .welcome-guide-message { bottom: 2px; padding: 11px 13px 9px; }
  .welcome-guide-message p { margin: 6px 0; font-size: 9.5px; }
  .welcome-employee-note { top: 2px; }
  .welcome-employee-details { gap: 5px 10px; margin-top: 5px; }
  .welcome-footer { min-height: 25px; padding-top: 6px; }
}

/* Very short windows */
@media (min-width: 721px) and (max-height: 700px) {
  .scene-title { font-size: clamp(32px, 4vw, 52px) !important; }
  .scene-intro { font-size: 12px !important; line-height: 1.4 !important; }
  .scene-stat { min-height: 54px; padding: 7px 11px; }
  .scene-item { min-height: 50px; padding: 7px 9px; }
  .scene-item-copy strong { font-size: 11px; }
  .scene-item-copy > span { font-size: 9.5px; }
  .guide-image-wrap { height: 43vh; width: min(24vw, 270px); }
  .guide-caption { padding: 10px 12px; }
  .guide-caption p { max-height: 48px; margin: 7px 0; font-size: 10px; }
  .guide-controls { margin-top: 8px; }
  .scene-bottomline { font-size: 7.5px; }
}
@media (min-width: 721px) and (max-height: 680px) {
  .welcome-copy h1 { font-size: clamp(34px, 4vw, 48px); }
  .welcome-description { font-size: 11px; line-height: 1.4; }
  .welcome-chapters { margin-top: 9px; }
  .welcome-chapter { min-height: 26px; padding: 5px 7px; }
  .welcome-guide-image { height: 40vh; width: min(24vw, 280px); }
  .welcome-guide-message { padding: 9px 11px 8px; }
  .welcome-guide-message p { font-size: 8.5px; margin: 5px 0; }
  .welcome-employee-details { display: none; }
}

/* Tablet/mobile tools */
@media (max-width: 760px) {
  .induction-tools { right: 14px; bottom: 16px; }
  .induction-tool-panels { right: 58px; flex-direction: column; align-items: flex-end; gap: 10px; }
  .induction-tool-panel {
    width: min(370px, calc(100vw - 95px));
    flex: 0 0 auto;
    height: min(430px, calc(100dvh - 100px));
  }
  .induction-floating-actions .induction-tools-launcher,
  .induction-tools-launcher { width: 46px; height: 46px; min-height: 46px; }
  .induction-floating-label { display: none; }
}

/* Mobile */
@media (max-width: 720px) {
  .induction-scene { height: 100dvh; min-height: 0 !important; padding: 10px 14px 8px; }
  .scene-brand-context,
  .scene-brand-divider { display: none; }
  .scene-brand-name { font-size: 10px; letter-spacing: 0.05em; }
  .scene-topbar-right { gap: 8px; }
  .scene-chapter-count { padding: 4px 8px; font-size: 10px; }
  .induction-view-toggle button { padding: 7px 10px; font-size: 11px; gap: 5px; }

  .scene-layout {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr) auto;
    gap: 4px;
    padding: 8px 0;
  }
  .scene-copy { min-height: 0; }
  .scene-title { font-size: clamp(32px, 9.5vw, 50px) !important; }
  .scene-oversized-number { top: -40px; font-size: 120px; }
  .scene-intro { font-size: 13px !important; line-height: 1.55 !important; }
  .scene-stats { gap: 8px; }
  .scene-stat { min-width: 0; flex: 1 1 calc(50% - 8px); min-height: 66px; padding: 10px 12px; }
  .scene-stat-value { font-size: 21px; }
  .scene-items,
  .scene-businesses { grid-template-columns: 1fr; gap: 8px; }
  .scene-item { padding: 10px 12px; }
  .scene-item-copy > span { font-size: 10px; }
  .scene-feedback { padding: 13px; }
  .scene-bottomline { font-size: 7px; }

  .scene-guide { min-height: 0; height: clamp(145px, 25dvh, 220px); width: 100%; }
  .guide-image-wrap { height: 100%; width: auto; min-width: 0; min-height: 0; max-width: 190px; }
  .guide-orbit { width: 240px; }
  .guide-orbit-two { width: 290px; }
  .guide-glow { width: 240px; }
  .guide-caption { width: min(68%, 330px); right: 0; bottom: 0; padding: 9px 11px; border-radius: 16px; }
  .guide-caption p { max-height: 42px; margin: 6px 0; font-size: 9.5px; }
  .guide-nameplate { display: none; }

  .scene-footer { gap: 8px; flex-wrap: wrap; min-height: 42px; padding-top: 6px; }
  .scene-footer-left { font-size: 7px; }
  .scene-pagination { order: 3; width: 100%; justify-content: center; }
  .scene-footer-actions { margin-left: auto; }
  .scene-skip-button,
  .scene-next-button { font-size: 10px; }
  .scene-video-view { height: calc(100dvh - 130px); min-height: 260px; padding: 14px 10px; }

  /* Welcome: panel itself scrolls when the stack cannot fit */
  .induction-welcome {
    height: 100dvh;
    min-height: 100dvh;
    max-height: none;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 12px 16px 10px;
  }
  .welcome-header-note,
  .welcome-header .scene-brand-context,
  .welcome-header .scene-brand-divider { display: none; }
  .welcome-main { flex: 0 0 auto; grid-template-columns: minmax(0, 1fr); gap: 12px; padding: 18px 0; }
  .welcome-copy { max-height: none; overflow: visible; }
  .welcome-greeting { margin-top: 14px; }
  .welcome-copy h1 { font-size: clamp(38px, 10vw, 54px); line-height: 0.98; }
  .welcome-description { margin-top: 12px; font-size: 12.5px; }
  .welcome-meta { margin-top: 14px; gap: 17px; }
  .welcome-start-button { margin-top: 15px; }
  .welcome-chapters { margin-top: 17px; }
  .welcome-chapter-list { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .welcome-guide-stage { height: 330px; min-height: 330px; }
  .welcome-guide-image { width: 210px; height: 285px; min-width: 190px; min-height: 0; }
  .welcome-guide-orbit { width: 270px; }
  .welcome-guide-orbit-b { width: 320px; }
  .welcome-guide-glow { width: 280px; }
  .welcome-guide-message { width: min(100%, 340px); bottom: 0; padding: 11px 13px; }
  .welcome-employee-note { top: 0; }
  .welcome-employee-details { display: none; }
  .welcome-footer { flex-wrap: wrap; font-size: 7px; }
  .welcome-footer span:nth-child(2) { display: none; }
}

@media (max-width: 520px) {
  .induction-tool-panel { width: calc(100vw - 80px); height: min(420px, calc(100dvh - 90px)); }
}

@media (max-width: 480px) {
  .scene-brand-mark { width: 30px; height: 30px; }
  .scene-brand-name { max-width: 140px; overflow: hidden; text-overflow: ellipsis; }
  .scene-stat { flex-basis: 100%; }
  .scene-item-action { display: none; }
  .scene-item.scene-team-item { gap: 10px; padding: 11px; }
  .scene-team-item .team-lead-avatar { width: 44px; height: 44px; min-width: 44px; }
  .welcome-chapter-list { grid-template-columns: 1fr; }
}

@media (prefers-reduced-motion: reduce) {
  .induction-experience *,
  .induction-experience *::before,
  .induction-experience *::after,
  .welcome-copy,
  .welcome-guide-stage,
  .welcome-guide-image img,
  .welcome-guide-glow,
  .welcome-guide-orbit-a,
  .welcome-guide-orbit-b {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}

/* =========================================
   MOUNTAIN PARALLAX — append to InductionExperience.css
   Subtle corporate landscape layers, behind all page content.
========================================= */

.induction-scene {
  position: relative;
  isolation: isolate;
  overflow: hidden;
}

.mountain-parallax {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
  opacity: 0.7;
}

.mountain-layer {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  will-change: transform;
  transform: translate3d(0, 0, 0);
}

.mountain-shape {
  position: absolute;
  left: -10%;
  bottom: -3%;
  width: 120%;
  height: 48%;
  filter: blur(0.2px);
}

.mountain-back {
  transform: translate3d(0, var(--parallax-back, 0px), 0);
  opacity: 0.20;
}

.mountain-back .mountain-shape {
  background: linear-gradient(160deg, #a7c4d8 0%, #c9dce8 55%, #e6edf3 100%);
  clip-path: polygon(
    0 70%, 12% 30%, 22% 55%, 38% 5%, 52% 55%,
    65% 20%, 78% 60%, 90% 30%, 100% 65%, 100% 100%, 0 100%
  );
}

.mountain-middle {
  transform: translate3d(0, var(--parallax-middle, 0px), 0);
  opacity: 0.15;
}

.mountain-middle .mountain-shape {
  bottom: -7%;
  height: 38%;
  background: linear-gradient(160deg, #7fa7b7 0%, #b5cbd3 100%);
  clip-path: polygon(
    0 55%, 15% 15%, 28% 60%, 43% 5%, 60% 55%,
    75% 12%, 88% 58%, 100% 30%, 100% 100%, 0 100%
  );
}

.mountain-front {
  transform: translate3d(0, var(--parallax-front, 0px), 0);
  opacity: 0.10;
}

.mountain-front .mountain-shape {
  bottom: -12%;
  height: 30%;
  background: linear-gradient(180deg, #527c8b 0%, #7899a2 100%);
  clip-path: polygon(
    0 45%, 18% 5%, 35% 65%, 52% 15%, 72% 70%,
    86% 25%, 100% 55%, 100% 100%, 0 100%
  );
}

.mountain-atmosphere {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      ellipse at 75% 30%,
      rgba(176, 210, 225, 0.17),
      transparent 55%
    ),
    linear-gradient(
      180deg,
      transparent 45%,
      rgba(221, 234, 241, 0.12) 100%
    );
}

/* Keep the induction interface above the decorative landscape. */
.induction-scene > .scene-topbar,
.induction-scene > .scene-layout,
.induction-scene > .scene-video-view,
.induction-scene > .scene-footer {
  position: relative;
  z-index: 2;
}

.induction-scene > .scene-grain {
  z-index: 1;
  pointer-events: none;
}

@media (max-width: 768px) {
  .mountain-parallax {
    opacity: 0.42;
  }

  .mountain-shape {
    height: 34%;
  }  
}

@media (prefers-reduced-motion: reduce) {
  .mountain-layer {
    transform: none !important;
    will-change: auto;
  }
}

`
export default MyDiv
